// extracted by mini-css-extract-plugin
export default {"section":"AdminProfileView-module__section--GhFaL","label":"AdminProfileView-module__label--RZKgi"};